import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isValidUsPhone, normalizeUsPhone } from '../../shared/validators/phone.validator';

export interface CollectPhoneDialogData {
  email?: string;
}

/**
 * WI 58: "one more thing" dialog that collects a required, valid 10-digit US phone number.
 * Used by the Google and Facebook registration flows when the provider does not supply a phone,
 * so no phone-less player is finalized. Returns the normalized 10-digit phone on submit, or
 * undefined if dismissed.
 */
@Component({
  selector: 's18-collect-phone-dialog',
  templateUrl: './collect-phone-dialog.component.html'
})
export class CollectPhoneDialogComponent {
  phone: string = '';
  email: string;

  constructor(
    public dialogRef: MatDialogRef<CollectPhoneDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CollectPhoneDialogData
  ) {
    this.email = data && data.email ? data.email : '';
  }

  get isValid(): boolean {
    return isValidUsPhone(this.phone);
  }

  submit() {
    if (!this.isValid) {
      return;
    }
    this.dialogRef.close(normalizeUsPhone(this.phone));
  }

  cancel() {
    this.dialogRef.close();
  }
}
